<template>
  <v-card>
    <div class="d-flex v-list pl-6 py-4 text--secondary"
         style="border-bottom:1px solid rgba(0,0,0,0.12);">
      <!-- indeterminate_check_box -->
      <v-icon @click="toggleChildren"
              class="material-icons"
              color="primary">
        {{showChildren?'check_box':filtercheck()>0?'indeterminate_check_box':'check_box_outline_blank'}}
      </v-icon>
      <div class="pl-4 text-h6">
        {{containerName}}
      </div>
    </div>

    <div v-for="(item1,index2) in copylist"
         :key="index2"
         class="d-flex v-list pl-6 py-4">
      <v-icon @click.stop="changeicon(index2)"
              class="material-icons"
              color="primary">{{!item1.checked ?"check_box_outline_blank":'check_box'}}</v-icon>
      <div class="pl-4">
        {{item1.table_name}}
      </div>
    </div>
  </v-card>
</template>

<style scoped>
</style>

<script>
export default {
  components: {},
  props: {
    containerName: {
      type: String
    },
    list: {
      type: Array
    }
  },
  data () {
    return {
      showChildren: false,
      copylist: [],
      halfSelected: false //办选状态
    };
  },
  created () { },
  mounted () {
    this.copylist = this.list.map(item => {
      item.checked = false
      return item
    })
  },
  methods: {
    filtercheck () {
      return this.copylist.filter((item) => {
        return item.checked == true
      }).length
    },
    toggleChildren () { //全选 
      this.copylist = this.list.map((item, i) => {
        item.checked = !this.showChildren
        return item
      })
      this.showChildren = !this.showChildren
    },
    changeicon (index) {
      this.copylist = this.list.map((item, i) => {
        if (index == i) {
          item.checked = !item.checked
        }
        return item
      })
      // 循环查看是否全选
      const allChecked = this.copylist.every(item => {
        return item.checked == true
      })

      // 循环查看是否全选
      const someChecked = this.copylist.some(item => {
        return item.checked == false
      })
      // 如果 全部选中  
      if (allChecked) {
        this.showChildren = !this.showChildren
      }
      //选中一个
      if (someChecked) {
        this.showChildren = false
      }
    }
  },
  computed: {

  },
  watch: {
    // 因为名字和list是一起传过来的就监听名字就行了，就不深度监听数组了
    containerName () {
      this.copylist = this.list.map(item => {
        item.checked = false
        return item
      })
    }
  },
};
</script>

<style scoped>
</style>
